import { useRef } from 'react'

// 初回レンダー時、currentStateは初期値なので前回の状態は存在し得ないため、その時はundefinedを返す
const usePrevious = <T>(currentState: T): T | undefined => {
  const currentRef = useRef<T>(currentState)
  const previousRef = useRef<T>()

  // eslint-disable-next-line react-hooks/refs -- FIXME: eslint-plugin-react-hooks が 7.0.1 にバージョンアップした際にエラーになるようになったため一旦無視。ここのコードを触る際に修正してください🙏
  if (currentRef.current !== currentState) {
    // eslint-disable-next-line react-hooks/refs -- FIXME: eslint-plugin-react-hooks が 7.0.1 にバージョンアップした際にエラーになるようになったため一旦無視。ここのコードを触る際に修正してください🙏
    previousRef.current = currentRef.current
    // eslint-disable-next-line react-hooks/refs -- FIXME: eslint-plugin-react-hooks が 7.0.1 にバージョンアップした際にエラーになるようになったため一旦無視。ここのコードを触る際に修正してください🙏
    currentRef.current = currentState
  }

  // eslint-disable-next-line react-hooks/refs -- FIXME: eslint-plugin-react-hooks が 7.0.1 にバージョンアップした際にエラーになるようになったため一旦無視。ここのコードを触る際に修正してください🙏
  return previousRef.current
}

export default usePrevious
